<template>
    <b-card
        bg-variant="white"
        border-variant="0"
        class="login-card shadow"
        body-class="px-4 py-4"
        >
        <b-row class="border-bottom border-color-gray-200 pb-4 mb-4 mt-2">
            <b-col cols="12">
                <div class="d-flex justify-content-center align-items-center">
                    <b-img src="/images/tierzero_basic.svg" class="mx-auto" width="185" alt="TierZero" />
                </div>
            </b-col>
        </b-row>
        <slot />
        <b-row class="my-2">
            <b-col cols="12" class="">
                <hr>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" class="">
                <browser-support-guide class="" />
            </b-col>
        </b-row>
    </b-card>
</template>

<script>
import BrowserSupportGuide from '@shared_components/common/browser-support-guide.vue';

export default {
    name: 'auth-card',
    components: {
        BrowserSupportGuide
    }
}
</script>

<style>

</style>